var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"testRisk"},[_c('div',{staticClass:"risk_top"},[_c('div',[_vm._v("经过初步检测，您已达到"),_c('span',[_vm._v("红色涉税风险")]),_vm._v("，触碰税务稽查阀值，建议咨询税务专家解答。")])])])
}]

export { render, staticRenderFns }